/**
 * Shared React Context instance for theme.
 *
 * Lives in its own non-component module so both the Provider and the
 * `useTheme` hook can import it without breaking Fast Refresh.
 */

import { createContext } from 'react';

export type Theme = 'light' | 'dark';

export interface ThemeContextType {
  theme: Theme;
  toggleTheme: () => void;
}

export const ThemeContext = createContext<ThemeContextType | undefined>(undefined);
